import {EddlMergedAbstract} from '@app/services/analytics/EDDL/events/eddl-merged.abstract';
import {WindowObject} from '@spartacus/tracking/tms/core';

export interface EddlAdobeTrackingData {
  event?: string;
  mergeKey?: string;
  manualBeacon?: EddlBeaconKey;
  site?: {
    name?: string;
    country?: string;
  };
  user?: {
    loginStatus?: 'yes' | 'no';
    loginMethod?: 'manual' | 'auto';
    type?: string;
    scimUserId?: string
  };
  page?: {
    name?: string;
    detail?: string;
    section?: string;
    language?: string;
    country?: string;
    url?: string;
    template?: string;
    referrer?: string;
  };
  error?: {
    type?: string;
    pageUrl?: string;
    pageName?: string;
    pageSection?: string;
    description?: string;
  };
  search?: {
    term?: string;
    clickRank?: number;
    clickURL?: string;
    pageNumber?: number;
    location?: 'KSD' | 'SRP';
    clickTitle?: string;
    clickCategory?: EddlSearchClickType;
  };
  forms?: {
    uniqueID?: string;
    name?: string;
    referrer?: string;
    transactionID?: string;
    country?: string;
    errorDescription?: string;
  };
  asset?: {
    url?: string;
    page?: string;
  };
  ecommerce?: {
    cart?: {
      orderID?: string;
      currency?: string;
      id?: string;
      products?: EddlAdobeTrackingDataProductData[];
    };
    products?: EddlAdobeTrackingDataProductData[];
  };
}

export interface EddlAdobeTrackingDataProductData {
  name?: string;
  id?: string;
  quantity?: string;
  price?: string;
  currency?: string;
  findingMethod?: string;
  category?: string;
  partnerName?: string;
}

export type EddlSearchClickType =
  'search suggestions'
  | 'keyword search'
  | 'recently searched'
  | 'solution suggestions';

export enum EddlProductFindingMethods {
  CATEGORY_PAGE = 'Category Page',
  EXTERNAL_CAMPAIGN = 'External Campaign',
  FREE_ADD_ON = 'Free Add-On',
  INTERNAL_CAMPAIGN = 'Internal Campaign',
  MAINTENANCE = 'Maintenance',
  RECOMMENDATION = 'Recommendation',
  SEARCH_PAGE = 'Search Page',
  SITE_NAVIGATION = 'Site Navigation',
}


export enum EddlCollectionState {
  START = 'START',
  ADD = 'ADD',
  FINISH = 'FINISH'
}

export enum EddlBeaconKey {
  ST = 'ST',
  STL = 'STL',
}

export interface EddlTrackingQueue {
  event: EddlMergedAbstract;
  data: any;
  wo: WindowObject;
}

export interface EddlSessionHelperExtras {
  event: string;

  [param: string]: string;
}

export interface EddlSessionHelperContent {
  uniqueToken: string;
  extras: EddlSessionHelperExtras[]
}

export const SUPPORT_FORM_NAME = 'DCS_G_2023_06_PME_Support';
export const EDDL_STORAGE_HELPER_NAME = 'eddl:helper'
